import React from 'react';
import Code from './code';
import { slugify } from '../../lib/utils';
import MdxLink from './link';

type HeadingProps = {
  children?: React.ReactNode;
};

export const MdxComponents = {
  a: (props) => <MdxLink {...props} />,
  pre: (props) => <Code {...props} />,
  h2: ({ children }: HeadingProps) => {
    const id = slugify(children);
    return (
      <h2 className={`my-5 font-ptSerif font-medium leading-9 tracking-wide text-3xl`} id={`${id}`}>
        {children}
      </h2>
    );
  },
  h3: ({ children }: HeadingProps) => {
    const id = slugify(children);
    return (
      <h3 className={`my-5 font-ptSerif font-medium tracking-wide text-2xl`} id={`${id}`}>
        {children}
      </h3>
    );
  },
  h4: ({ children }: HeadingProps) => {
    const id = slugify(children);
    return (
      <h4 className={`my-5 font-ptSerif tracking-wide text-xl`} id={`${id}`}>
        {children}
      </h4>
    );
  },
  p: ({ children }) => <p className='my-4'>{children}</p>,
  blockquote: ({ children }) => (
    <blockquote className='pl-4 text-gray-700 border-l-2 border-gray'>{children}</blockquote>
  ),
  ul: ({ children }) => <ul className='pl-5 mb-8 list-disc'>{children}</ul>,
  ol: ({ children }) => <ol className='pl-5 mb-8 list-decimal'>{children}</ol>,
  li: ({ children }) => <li className='text-lg'>{children}</li>,
};
